import Picture1 from "../assets/clients/Picture1.png";
import Picture2 from "../assets/clients/Picture2.png";
import Picture3 from "../assets/clients/Picture3.png";
import Picture4 from "../assets/clients/Picture4.png";
import Picture5 from "../assets/clients/Picture5.png";
import Picture6 from "../assets/clients/Picture6.png";
import Picture7 from "../assets/clients/Picture7.png";
import Picture8 from "../assets/clients/Picture8.png";
import Picture9 from "../assets/clients/Picture9.png";
import Picture10 from "../assets/clients/Picture10.png";
import Picture11 from "../assets/clients/Picture11.png";
import Picture12 from "../assets/clients/Picture12.png";
import Picture13 from "../assets/clients/Picture13.png";
import Picture14 from "../assets/clients/Picture14.png";
import Picture15 from "../assets/clients/Picture15.png";
import Picture16 from "../assets/clients/Picture16.png";
import Picture17 from "../assets/clients/Picture17.png";
import Picture18 from "../assets/clients/Picture18.png";
import Picture19 from "../assets/clients/Picture19.png";
import Picture20 from "../assets/clients/Picture20.png";

const clientsData = [
  {
    id: 1,
    name: "Picture1",
    image: Picture1,
  },
  {
    id: 2,
    name: "Picture2",
    image: Picture2,
  },
  {
    id: 3,
    name: "Picture3",
    image: Picture3,
  },
  {
    id: 4,
    name: "Picture4",
    image: Picture4,
  },
  {
    id: 5,
    name: "Picture5",
    image: Picture5,
  },
  {
    id: 6,
    name: "Picture6",
    image: Picture6,
  },
  {
    id: 7,
    name: "Picture7",
    image: Picture7,
  },
  {
    id: 8,
    name: "Picture8",
    image: Picture8,
  },
  {
    id: 9,
    name: "Picture9",
    image: Picture9,
  },
  {
    id: 10,
    name: "Picture10",
    image: Picture10,
  },
  {
    id: 11,
    name: "Picture11",
    image: Picture11,
  },
  {
    id: 12,
    name: "Picture12",
    image: Picture12,
  },
  {
    id: 13,
    name: "Picture13",
    image: Picture13,
  },
  {
    id: 14,
    name: "Picture14",
    image: Picture14,
  },
  {
    id: 15,
    name: "Picture15",
    image: Picture15,
  },
  {
    id: 17,
    name: "Picture17",
    image: Picture17,
  },
  {
    id: 16,
    name: "Picture16",
    image: Picture16,
  },
  {
    id: 18,
    name: "Picture18",
    image: Picture18,
  },
  {
    id: 19,
    name: "Picture19",
    image: Picture19,
  },
  {
    id: 20,
    name: "Picture20",
    image: Picture20,
  },

];

export default clientsData;
